import { throwErrorMessage } from 'dashboard/store/utils/api';

/**
 * List pages are reused when only the assistant route param changes. This
 * wrapper prevents a slower request for the previous assistant from replacing
 * the newer assistant's records when responses arrive out of order.
 */
export const createLatestListRequest = (API, mutations) => {
  let requestVersion = 0;

  const invalidate = () => {
    requestVersion += 1;
  };

  const get = async ({ commit }, params = {}) => {
    requestVersion += 1;
    const currentVersion = requestVersion;
    commit(mutations.SET_UI_FLAG, { fetchingList: true });

    try {
      const response = await API.get(params);
      const { payload, meta } = response.data;

      if (currentVersion !== requestVersion) return payload;

      commit(mutations.SET, payload);
      commit(mutations.SET_META, meta);
      return payload;
    } catch (error) {
      if (currentVersion !== requestVersion) return undefined;
      return throwErrorMessage(error);
    } finally {
      if (currentVersion === requestVersion) {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    }
  };

  return { get, invalidate };
};
